import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SortablejsModule } from 'ngx-sortablejs';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { ProjectBoardDetailUpdateDialogComponent } from './update-details-dialog/board-update-details-dialog.component';
import { TruncateModule } from 'ng2-truncate';
import { ProjectBoardAttachmentDisplayComponent } from './card/attachment-display/attachment-display.component';
import { BoardSubscribeDialogComponent } from './board-subscribe-dialog/board-subscribe-dialog.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgMentionsModule } from '@nth-cloud/ng-mentions';
import { CommentDialogComponent } from './card/comment-dialog/comment-dialog.component';
import { TagifyModule } from 'ngx-tagify';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { AddBoardModalComponent } from './card/add-board-modal/add-board-modal.component';



@NgModule({
    declarations: [
        ProjectBoardDetailUpdateDialogComponent,
        ProjectBoardAttachmentDisplayComponent,
        BoardSubscribeDialogComponent,
        BoardSubscribeDialogComponent,
        CommentDialogComponent,
        AddBoardModalComponent,
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatButtonModule,
        MatDividerModule,
        MatListModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        TagifyModule,
        CKEditorModule,
        MatInputModule,
        MatNativeDateModule,
        MatMomentDateModule,
        DragDropModule, 
        MatTabsModule,
        MatToolbarModule,
        MatStepperModule,
        MatDatepickerModule,
        MatRadioModule,
        MatTableModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatCardModule,
        MatMenuModule,
        MatProgressBarModule,
        MatTooltipModule,
        TranslateModule,
        TruncateModule,
        NgMentionsModule,
        SortablejsModule,
        FormsModule,
    ]
})
export class BoardDialogsModule { }
